import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {AppComponent} from '../../app.component';
import { from } from 'rxjs';
import posthog from 'posthog-js'
// Services
import {ModuleService} from '../../services/modules.service';
import {OAuthService} from '../../services/oauth.service';
import {GlobalFlagsService} from '../../services/global-flags.service';
import {CustomPageService} from '../../services/custom-page.service';
import {StorageService} from '../../services/storage.service';
import { DialogLoginHospital } from '../commons/dialog-login-hospital/dialog-login-hospital.component';
import { RegistrationService } from '../../services/registration.service';
import { CookieService } from 'ngx-cookie';
import { DialogService } from '../../services/dialog.service';
import {environment} from '../../../environments/environment';
declare let $:any;


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  constructor(public router: Router,
    private route: ActivatedRoute,
    private oauthService: OAuthService,
    private moduleService: ModuleService,
    private storageService: StorageService,
    private globalFlagsService: GlobalFlagsService,
    private customPageService: CustomPageService,
    private dialog: MatDialog,
    private registrationService: RegistrationService,
    private appComponent: AppComponent,
    private cookieService: CookieService,
    private dialogService: DialogService
  ) {

  }

  myUser = null;
  isLoading = false;
  invalidCredentials = false;
  returnUrl: string;
  messageError = null;
  errorOnLogin = false;
  errorSSOCookieMessage = 'A different user is already logged in via SSO.';
  errorSSOCookie = false;
  loginData = { username: this.oauthService.emailRemember(), password: '' };
  email = this.oauthService.emailRemember;
  rememberMe = false;
  disabled = false;
  public href: string = "";
  dev = false;
  loggedInLocalhost = false;
  sessionExpired = this.appComponent.isSessionExpired();
  year= new Date().getFullYear();
  image1 = "/1.jpg";
  image2 = "/2.jpg";
  image3 = "/3.jpg";
  image4 = "/4.jpg";
  image5 = "/5.jpg";
  logo = "menu_logo.png";



  public error = null;

  ngOnInit() {
    this.storageService.setClinicName("MyCareReport")
    this.globalFlagsService.displayLoad(false);
    this.isLoading = false;
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.error = false;
    this.href = window.location.origin;
    this.dev = this.href.includes("dev");
    this.loggedInLocalhost = environment.url.api.includes("localhost");
    // Posthog logging for PROD. setPosthogEnabled true to work aftewrads.
    /*if (environment.production) {
      posthog.init(environment.posthog.token,environment.posthog.config);
      this.globalFlagsService.setPosthogEnabled(true);
    }
    else{
      this.globalFlagsService.setPosthogEnabled(false);
    }*/
    this.globalFlagsService.setPosthogEnabled(false);
  }

  ngAfterViewInit() {
    $('.passcode-switch').click(function (e) {
      e.preventDefault();
      var passInput=$('#password');
      if (passInput.attr('type')==='password') {
          passInput.attr('type', 'text');
          $('.ni-eye').hide();
          $('.ni-eye-off').show();
      } else {
         passInput.attr('type','password');
         $('.ni-eye').show();
         $('.ni-eye-off').hide();
      }
    });


    let slideIndex = 1;
    showSlides(slideIndex);

    // Next/previous controls
    function plusSlides(n) {
        showSlides(slideIndex += n);
    }

    function showSlides(n) {
        let i;
        if (document.querySelector(".carousel")) {
            let slideshowPage = document.querySelector(".carousel");
            if (slideshowPage.classList.contains("carousel")) {
                let slides = slideshowPage.querySelectorAll<HTMLElement>(".carousel-item");
                if (n > slides.length) {
                slideIndex = 1
                };
                if (n < 1) {
                slideIndex = slides.length
                };
            for (i = 0; i < slides.length; i++) {
                slides[i].classList.remove("active");
            };
            slides[slideIndex-1].classList.add("active");
            }
        }
    }

    setInterval(function() {
      plusSlides(1);
    }, 8000);


  }


  login() {
    if (!this.loginData.username || !this.loginData.password) {
      if (!this.moduleService.getUsername()&& !this.moduleService.getPassword()) {
        this.errorOnLogin = true;
        this.messageError = 'Please enter valid credentials';
        this.router.navigate(['/login']);
      }
      else {
        this.loginData.username = this.moduleService.getUsername();
        this.loginData.password = this.moduleService.getPassword();
      }
    }
    this.messageError = this.errorOnLogin = null;
    this.isLoading = true;
    this.errorOnLogin = false;
    this.invalidCredentials = false;
    this.loginData.username = this.loginData.username.trim();
    this.oauthService.login(this.loginData.username, this.loginData.password, this.rememberMe)
      .subscribe(
      (res) => {
        let userId: string = res.userId;
        let fullName: string = res.fullName;
        let username: string = res.username;
        let hospitals: any = res.hospitals;
        let mfaEnabled:boolean = res.mfaEnabled;
        let phone: string = res.phoneNumber;
        let mfaCookies_string = this.cookieService.get(this.oauthService.USERNAME_COOKIE);
        let mfaCookies_array = [];
        if(mfaCookies_string){
          mfaCookies_array = JSON.parse(mfaCookies_string);
        }
        if(mfaEnabled && !this.isUserInCookies(mfaCookies_array,username) && !this.loggedInLocalhost){
          if ( !this.moduleService.isMfaAlreadyChecked() ) {
            this.oauthService.mfa(phone,(status) => {
            if (status) {
              this.moduleService.setUsername(this.loginData.username);
              this.moduleService.setPassword(this.loginData.password);
              this.router.navigate([ '/mfaLogin' ]);
            }
            });
          }

        } else {
          // identify user for posthog
          if(this.globalFlagsService.isPosthogEnabled){
            posthog.identify(userId, {
              provider: hospitals
            })
          }
            if (this.isAdmin(res.roles)) {
              this.globalFlagsService.displayLoad(true);
              this.redirectToAdmin();
            }
            else {
                this.globalFlagsService.setUserLogged(true);
                this.globalFlagsService.setIsFromLogin(true);
                this.storageService.setLoginEmail(this.loginData.username);
                this.isLoading = false;
                if(this.moduleService.isLocalResourcesAvailable())
                {
                  const localResources = from(this.customPageService.getLocalResources());
                  localResources
                  .subscribe(() => { },
                  err => {
                    localStorage.setItem('disableLocalResources', 'true');
                  });

                }
                if(this.moduleService.isHelpLineAvailable())
                {
                  const helpLine = from(this.customPageService.getHelpLine());
                  helpLine
                  .subscribe(() => { },
                  err => {
                    localStorage.setItem('disableHelpLine', 'true');
                  });
            }
            // login successful
            if(Object.keys(hospitals).length > 1){
              const dialogRef = this.dialog.open(DialogLoginHospital, {data: {hospitals:hospitals}});
              dialogRef.afterClosed().subscribe(hospitalId => {
                if (hospitalId) {
                  this.loginInSelectedHospital(hospitalId)
                }
              })
            } else {
              this.router.navigate([this.returnUrl]);
            }
          }
        }
      },
      (error) => {
        this.errorOnLogin = true;
        setInterval(function() {
          let element = $(".alert-dismissible");
          element.hide();
        }, 4000);
        this.messageError = error.error.error_description || 'Problem connecting to authentication server, please try again soon.';
        this.isLoading = false;
      }
      );
  }

  isAdmin(roles) {
    const isAdmin = roles.filter(role => {
      return role === 'F' || role === 'A' || role === 'E' || role === 'X' || role === 'Y' || role === 'D' || role === 'B' || role === 'L';
    })[0];
    return isAdmin;
  }


  get loginLogo() {
    return 'cancer-support-community.png';
  }


    isUserInCookies(array,username):boolean{
      let result:boolean = false;
      let i = 0;
      if(array.length>0){
        while(i<array.length-1 && username!=array[i].username) {
          i++;
        }
        if(username.toLowerCase() == array[i].username.toLowerCase()) {
         let d = new Date();
         d.setDate(d.getDate() + 0 );
         let arrayDate:Date = new Date(array[i].date);
          if (arrayDate >  d) {
            result = true;
          }
        }
      }
      return result;
    }

  redirectToAdmin() {
      const redirect = (url, method) => {
      const form = document.createElement('form');
      document.body.appendChild(form);
      form.method = method;
      form.action = url;

      const username = document.createElement('input');
      username.type = 'text';
      username.id = 'usernameRedirect';
      username.name = 'username';
      username.value = this.loginData.username;
      username.type = 'hidden';
      form.appendChild(username);

      const password = document.createElement('input');
      password.type = 'password';
      password.id = 'passwordRedirect';
      password.name = 'password';
      password.value = this.loginData.password;
      password.type = 'hidden';
      form.appendChild(password);
      form.submit();
    };

    redirect(`${environment.url.adminLoginUrl}`, 'post');
  }

  redirectToGeneralSupport() {
    const redirect = (url, method) => {
      const form = document.createElement('form');
      document.body.appendChild(form);
      form.method = method;
      form.action = url;

      const username = document.createElement('input');
      username.type = 'text';
      username.id = 'usernameRedirect';
      username.name = 'username';
      username.value = this.loginData.username;
      form.appendChild(username);

      const password = document.createElement('input');
      password.type = 'password';
      password.id = 'passwordRedirect';
      password.name = 'password';
      password.value = this.loginData.password;
      form.appendChild(password);

      form.submit();
    };
    redirect(`${environment.url.mcrUrl}`, 'post');
  }

  loginInSelectedHospital(hospitalId) {

    this.globalFlagsService.displayLoad(true);
    let token = OAuthService.getAccessToken();
    const confirmation = from(this.registrationService.reLogin({hospitalId, token}));
    confirmation
      .subscribe((res: any) => {
        if (res != null) {
          if (res.oAuth2AccessToken != undefined){
            this.oauthService.logout();
            this.oauthService.authenticate(res.oAuth2AccessToken);
            this.globalFlagsService.setUserLogged(true);
            this.globalFlagsService.setIsFromLogin(true);
            if (res.headerViewModel != null){
                this.storageService.setUsername(res.headerViewModel.userFirstName);
                this.storageService.setIdHospital(res.headerViewModel.idHospital);
                this.storageService.setClinic(res.headerViewModel.clinic);
                this.storageService.setShowName(res.headerViewModel.showName);
                OAuthService.saveAppModules(res.headerViewModel.appModules);
                OAuthService.saveLanguage(res.headerViewModel.lang);
                OAuthService.saveLanguageCode(res.headerViewModel.langCode);
            }
          if (this.moduleService.isLocalResourcesAvailable()) {
            const localResources = from(this.customPageService.getLocalResources());
            localResources
            .subscribe(() => { },
            err => {
              localStorage.setItem('disableLocalResources', 'true');
            });
          }
          if(this.moduleService.isHelpLineAvailable())
          {
            const helpLine = from(this.customPageService.getHelpLine());
            helpLine
            .subscribe(() => { },
            err => {
              localStorage.setItem('disableHelpLine', 'true');
            });
          }
            if (res.formInstanceId != null){
                this.router.navigate(['/form/startInstance/', res.formInstanceId]);
            }
          }
        }
        this.globalFlagsService.displayLoad(false);
        this.router.navigate([this.returnUrl]);
      });
  }
}
